import Vue from 'vue';
import App from './App.vue';
import './registerServiceWorker';
import router from './router';
import store from './store';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import EditTemplates from "@/components/editTemplates.vue";
import ZIXUN from "@/components/zixun.vue";
import MetaInfo from 'vue-meta-info'
import four4four from "@/views/404.vue"
Vue.use(four4four)
Vue.use(MetaInfo)
Vue.config.productionTip = false;
Vue.use(ElementUI)
Vue.component('ZIXUN', ZIXUN)
Vue.component('EditTemplates', EditTemplates)
new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');

router.beforeEach((to, from, next) => {
  if (to.matched.length ===0) {                                 //如果未匹配到路由
    next('404');
  } else { 
    next();                                                                            //如果匹配到正确跳转
  }

});